import { render, staticRenderFns } from "./ConfirmModalDemo.vue?vue&type=template&id=22912b40&scoped=true&"
import script from "./ConfirmModalDemo.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22912b40",
  null
  
)

export default component.exports